import React, {useEffect, useState} from 'react';
import {httpsCallable} from 'firebase/functions';
import {functions} from '../Security/firebase-config';
import '../components/guide-authoring/GuideAuthoring.css';

const loadReport = httpsCallable(functions, 'getCostTrackingReport');
const reports = {teams: 'Team billing cycles', plans: 'Plan comparison', operations: 'Firestore operations'};
const dollars = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 6});

export default function CostTrackingPage() {
  const [report, setReport] = useState('teams');
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!month) return undefined;
    let active = true;
    loadReport({report, month}).then(result => {
      if (active) setState({report, month, data: result.data});
    }).catch(error => {
      if (active) setState({report, month, error: error.message || 'Cost report unavailable.'});
    });
    return () => { active = false; };
  }, [report, month]);

  const current = state?.report === report && state?.month === month ? state : null;
  const data = current?.data;
  return <main className="GA">
    <header className="GA__heading"><h1>Cost tracking</h1></header>
    <p>Internal reporting. Media costs and operation costs are estimates. Blank amounts have no reconciled input.</p>
    <div className="GA__filters">
      <label>Report<select value={report} onChange={event => setReport(event.target.value)}>
        {Object.entries(reports).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </select></label>
      <label>{report === 'operations' ? 'Usage month (UTC)' : 'Billing cycle start month (UTC)'}
        <input type="month" value={month} onChange={event => setMonth(event.target.value)}/>
      </label>
    </div>
    {report === 'operations' && <p>Counts cover observed changes to team calendars and supported note documents. These estimates are separate from the media margin.</p>}
    {!month ? <p>Choose a month.</p> : !current ? <p role="status">Loading report…</p> :
      current.error ? <p role="alert">{current.error}</p> :
      !data.rows.length ? <p>No report rows for this month.</p> :
      <>
        {data.truncated && <p role="status">Showing the first 500 rows.</p>}
        <div style={{overflowX: 'auto'}}>
          <table cellPadding="8">
            <thead><tr>{data.fields.map(field => <th key={field} scope="col">{field.replaceAll('_', ' ')}</th>)}</tr></thead>
            <tbody>{data.rows.map((row, index) => <tr key={index}>{row.map((value, column) =>
              <td key={data.fields[column]}>{value == null ? '—' :
                data.fields[column].endsWith('_usd') ? dollars.format(Number(value)) : value}</td>
            )}</tr>)}</tbody>
          </table>
        </div>
      </>}
  </main>;
}
